import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RequestInfo.css';

const RequestInfo = ({ title }) => {
  const navigate = useNavigate();
  return (
    <section className="request-info-section">
      <div className="request-info-container">
        <div className="request-info-spacer-left"></div>
        <p className="request-info-text">
          {title || <>Deploy AI That Regulators Trust.</>}
        </p>
        <button className="request-info-button" onClick={() => navigate('/contact')}>
          Request for demo
        </button>
      </div>
    </section>
  );
};

export default RequestInfo; 